/**
 * @type {ng.IDirectiveFactory}
 * @param {import('../core').UserService} userService
 */
export default function verifyEmailExistsDirective(userService) {
  'ngInject'

  return {
    restrict: 'A',
    require: 'ngModel',
    link(scope, elem, attrs, controller) {
      const ngModel = /** @type {ng.INgModelController} */ (controller)
      ngModel.$asyncValidators.email = (modelValue, viewValue) => userService.exists(modelValue || viewValue)
    }
  }
}
